<template>
  <v-card>
    <v-toolbar color="white" elevation="0">
      <template v-slot:extension>
        <v-tabs v-model="tabs" centered>
          <v-tab dark>
            <label class="primary_whiten--text"> Positive </label></v-tab
          >
          <v-tab class="orange--text">Negative</v-tab>
        </v-tabs>
      </template>
    </v-toolbar>
    <v-divider> </v-divider>

    <v-tabs-items v-model="tabs">
      <v-tab-item>
        <v-row>
          <v-col cols="12" v-for="(item, index) in allPositiveResults" :key="index">
          <v-card
          >
            <v-card-title class="text-h5">
              {{item}}
            </v-card-title>

            <v-card-actions>
              <v-btn class="elevation-2 mb-5" rounded text @click="change_status(item, 'Negative')">
                Change to Negative
              </v-btn>
            </v-card-actions>
          </v-card>
          </v-col>
        </v-row>
      </v-tab-item>

      <v-tab-item>
        <v-row>
          <v-col cols="12" v-for="(item, index) in allNegativeResults" :key="index">
          <v-card
          >
            <v-card-title class="text-h5">
              {{item}}
            </v-card-title>

            <v-card-actions>
              <v-btn class="elevation-2 mb-5" rounded text @click="change_status(item, 'Positive')">
                Change to Positive
              </v-btn>
            </v-card-actions>
          </v-card>
          </v-col>
        </v-row>
      </v-tab-item>
    </v-tabs-items>
  </v-card>
</template> 


<script>
import { mapFields } from "vuex-map-fields";
import { mapActions } from "vuex";

export default {
  async created() {
    await this.fetchAllContact();
  },
    computed: {
  ...mapFields("contact_tracing", ["allPositiveResults", "allNegativeResults"]),
  },
      methods: {
    ...mapActions("contact_tracing", ["fetchAllContact", "updateContact"]),
    async change_status(number, new_state) {
        await this.updateContact({id: number, state: new_state});
        await this.fetchAllContact();

    },
    },
data() {
    return {
      tab: null,
      tabs: null,

    };
  }
}
</script>